// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Badge-module_badgeWrapper__Jd68P","homepage":"Badge-module_homepage__wolbj","hide":"Badge-module_hide___Jblx","floating":"Badge-module_floating__HUHe1"};